import { useId } from 'react';
import PropTypes from "prop-types";
import { Icon } from '@iconify/react';
import { mergeClasses } from 'minimal-shared/utils';

import { styled } from '@mui/material/styles';

import { allIconNames, registerIcons } from './register-icons';

// ----------------------------------------------------------------------

export function Iconify({ className, icon, width = 20, height, sx, ...other }) {
  const id = useId();

  if (!allIconNames.includes(icon)) {
    console.warn(
      [
        `Icon "${icon}" is currently loaded online, which may cause flickering effects.`,
        `To ensure a smoother experience, please register your icon collection for offline use.`,
        `More information is available at: https://docs.minimals.cc/icons/`,
      ].join('\n')
    );
  }

  registerIcons();

  return (
    <IconRoot
      ssr
      id={id}
      icon={icon}
      className={mergeClasses([ className])}
      sx={[
        {
          width,
          flexShrink: 0,
          height: height ?? width,
          display: 'inline-flex',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    />
  );
}

// ----------------------------------------------------------------------

const IconRoot = styled(Icon)``;



Iconify.propTypes = {
  className: PropTypes.any,
  height: PropTypes.any,
  icon: PropTypes.any,
  sx: PropTypes.object,
  width: PropTypes.any,
};
